import { User } from '../models/user.model';
import { Appointment } from '../models/appointment.model';

// ── Mock Users ────────────────────────────────────────────────────────────────
export const MOCK_USERS: User[] = [
  {
    id: 'admin-001',
    name: 'Administrador',
    email: 'admin',
    role: 'professional',
    specialty: 'Administración del sistema',
  },
  {
    id: 'pro-001',
    name: 'Dra. Elena Rossi',
    email: 'elena@fluidarchitects.com',
    role: 'professional',
    specialty: 'Arquitectura · Diseño de interiores',
  },
  {
    id: 'pro-002',
    name: 'Arq. Martín Vega',
    email: 'martin@fluidarchitects.com',
    role: 'professional',
    specialty: 'Diseño estructural · Sustentabilidad',
  },
  {
    id: 'pro-003',
    name: 'Lic. Sofia Paredes',
    email: 'sofia@fluidarchitects.com',
    role: 'professional',
    specialty: 'Paisajismo · Espacios verdes',
  },
  {
    id: 'client-001',
    name: 'Juan García',
    email: 'juan@ejemplo.com',
    role: 'client',
  },
  {
    id: 'client-002',
    name: 'María López',
    email: 'maria@ejemplo.com',
    role: 'client',
  },
];

// ── Mock passwords (email → password) ─────────────────────────────────────────
export const MOCK_PASSWORDS: Record<string, string> = {
  'admin':                      'admin',
  'elena@fluidarchitects.com':  '1234',
  'martin@fluidarchitects.com': '1234',
  'sofia@fluidarchitects.com':  '1234',
  'juan@ejemplo.com':           '1234',
  'maria@ejemplo.com':          '1234',
};

/** Professionals visible to clients when booking */
export const BOOKABLE_PROFESSIONALS = MOCK_USERS.filter(
  u => u.role === 'professional' && u.id !== 'admin-001'
);

// ── Generate date strings relative to today ───────────────────────────────────
function dateStr(offsetDays: number): string {
  const d = new Date();
  d.setDate(d.getDate() + offsetDays);
  return d.toISOString().split('T')[0];
}

function isoNow(offsetDays = 0): string {
  const d = new Date();
  d.setDate(d.getDate() - offsetDays);
  return d.toISOString();
}

// ── Mock Appointments ─────────────────────────────────────────────────────────
export const MOCK_APPOINTMENTS: Appointment[] = [
  {
    id: 'apt-001',
    clientId: 'client-001',
    clientName: 'Juan García',
    clientEmail: 'juan@ejemplo.com',
    professionalId: 'pro-001',
    professionalName: 'Dra. Elena Rossi',
    date: dateStr(1),
    time: '10:00',
    duration: 60,
    serviceType: 'Consulta inicial 60 min',
    notes: 'Proyecto de remodelación · Planta baja',
    status: 'confirmed',
    createdAt: isoNow(2),
  },
  {
    id: 'apt-002',
    clientId: 'client-002',
    clientName: 'María López',
    clientEmail: 'maria@ejemplo.com',
    professionalId: 'pro-001',
    professionalName: 'Dra. Elena Rossi',
    date: dateStr(1),
    time: '14:00',
    duration: 30,
    serviceType: 'Revisión de planos 30 min',
    status: 'pending',
    createdAt: isoNow(1),
  },
  {
    id: 'apt-003',
    clientId: 'client-001',
    clientName: 'Juan García',
    clientEmail: 'juan@ejemplo.com',
    professionalId: 'pro-001',
    professionalName: 'Dra. Elena Rossi',
    date: dateStr(3),
    time: '11:30',
    duration: 60,
    serviceType: 'Consulta inicial 60 min',
    notes: 'Segunda reunión · Cotización final',
    status: 'confirmed',
    createdAt: isoNow(0),
  },
  {
    id: 'apt-004',
    clientId: 'client-002',
    clientName: 'María López',
    clientEmail: 'maria@ejemplo.com',
    professionalId: 'pro-001',
    professionalName: 'Dra. Elena Rossi',
    date: dateStr(-1),
    time: '09:00',
    duration: 30,
    serviceType: 'Revisión de planos 30 min',
    status: 'confirmed',
    createdAt: isoNow(4),
  },
];

// ── Available time slots (professional's working hours) ───────────────────────
export const WORKING_HOURS: string[] = [
  '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
  '14:00', '14:30', '15:00', '15:30', '16:00', '16:30',
];

// ── Service types ─────────────────────────────────────────────────────────────
export const SERVICE_TYPES = [
  { label: 'Consulta inicial 30 min',   duration: 30, price: 8000  },
  { label: 'Consulta inicial 60 min',   duration: 60, price: 14000 },
  { label: 'Revisión de planos 30 min', duration: 30, price: 6000  },
  { label: 'Revisión de planos 60 min', duration: 60, price: 11000 },
];
